import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MentorSessionRazorpayOrderResponse, RazorPaymentPayload } from '@edtech-ui/core/models/mentors-sessions/create-order-razorpay';
import { PaymentHistoryResponse } from '@edtech-ui/core/models/mentors-sessions/get-payment-history';
import { RazorPaymentVerifyPayload, RazorPaymentVerifyResponse } from '@edtech-ui/core/models/mentors-sessions/post-razor-payment-verify';
import { StudentPaymentActivePayload, SubscriptionActivateResponse } from '@edtech-ui/core/models/student-courses-v2/student-payment-activate';
import { PackageProductsResponse } from '@edtech-ui/core/models/student-courses-v2/student-products-lists';
import { StudentReferralCodePayload, StudentReferralDiscountResponse } from '@edtech-ui/core/models/student-courses-v2/student-referral-code';
import { StudentTransactionsResponse } from '@edtech-ui/core/models/student-courses-v2/student-transcation-payments';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class PaymentService {

	apiUrl = environment.paymentApiUrl;

	orderId = new BehaviorSubject<string>('');
	razorpayOrderId = new BehaviorSubject<string>('');
	razorPayPaymentId = new BehaviorSubject<string>('');

	constructor(private http: HttpClient) { }

	postCreateOrderRazorPayment(payload: RazorPaymentPayload): Observable<MentorSessionRazorpayOrderResponse> {
		return this.http.post<MentorSessionRazorpayOrderResponse>(`${this.apiUrl}/create-order`, payload)
	}

	postRazorPaymentVerify(payload: RazorPaymentVerifyPayload): Observable<RazorPaymentVerifyResponse> {
		return this.http.post<RazorPaymentVerifyResponse>(`${this.apiUrl}/verify`, payload);
	}

	getCompleteHistoryPayment(pageNo = 1, pageLimit = 10): Observable<PaymentHistoryResponse> {
		const params = new HttpParams().set('page', pageNo).set('limit', pageLimit)
		return this.http.get<PaymentHistoryResponse>(`${this.apiUrl}/user/history`, { params });
	}

	getStudentProducts(): Observable<PackageProductsResponse> {
		return this.http.get<PackageProductsResponse>(`${this.apiUrl}/products/packages`);
	}

	postPaymentActiveSubscription(payload: StudentPaymentActivePayload): Observable<SubscriptionActivateResponse> {
		return this.http.post<SubscriptionActivateResponse>(`${this.apiUrl}/activate-subscription`, payload);
	}

	getStudentsTranscations(pageNo = 1, pageSize = 10): Observable<StudentTransactionsResponse> {
		const params = new HttpParams().set('page', pageNo).set('page_size', pageSize);
		return this.http.get<StudentTransactionsResponse>(`${this.apiUrl}/transactions`, { params });
	}

	getPaymentTranscationDownload(orderId: string) {
		return this.http.get(`${this.apiUrl}/transactions/${orderId}/invoice/download`, { responseType: 'blob' })
	}

	getStudentReferralCode( pricingId: string, refCode: string, useInviteCount: boolean): Observable<StudentReferralDiscountResponse> {
		const params = new HttpParams().set('pricing_id', pricingId).set('code', refCode).set('use_invite_count', useInviteCount)
		return this.http.get<StudentReferralDiscountResponse>(`${this.apiUrl}/apply-coupon` , { params});
	}

}
